import { Module } from 'vuex';

import { errorCodes } from '@/api/errorCodes';
import { cartGtmEvents } from '@/gtm/cart';

const formatNotification = (n: INotification) => {
  const notification = { ...n };
  if (typeof notification.message === 'object') {
    if (!notification.title && notification.type === 'error') {
      notification.title = 'Ошибка';
    }

    const { status } = notification.message;
    let { errors = {} } = notification.message;

    if (Array.isArray(errors) && errors.length) {
      // eslint-disable-next-line prefer-destructuring
      errors = errors[0];
    }
    const { code, detail } = errors;
    if (status && code) {
      notification.message = errorCodes[code as keyof typeof errorCodes] || detail || '';

      if (process.env.NODE_ENV === 'development') {
        notification.title += ` (${status})`;
        notification.message += ` (${code})`;
      }
    }
  }
  return notification;
};

interface INotificationState {
  items: INotification[];
}

export interface INotification {
  id?: string | number;
  title?: string;
  message?: string | any;
  type?: string,
  color?: string,
  lifetime?: number,
  closable?: boolean,
  onShown?: () => void;
  onClose?: () => void;
}

// Потому что нет типизации ставим any
type TRootStore = any;

const notificationStore: Module<INotificationState, TRootStore> = {
  namespaced: true,

  state: () => ({
    items: [],
  }),

  getters: {
    list: (state) => state.items,
  },

  mutations: {
    add: (state, notification) => state.items.push(notification),

    remove: (state, id) => {
      state.items = state.items.filter((i) => i.id !== id);
    },
  },

  actions: {
    create({ state, rootState, commit }, payload: INotification) {
      const data: INotification = {
        id: Math.random().toString(36).slice(2, 11),
        title: '',
        message: '',
        type: 'error',
        color: '',
        lifetime: 5,
        closable: true,

        ...payload,
      };

      if (state.items.findIndex((n) => n.id === data.id) !== -1) {
        return; // дублирование id
      }

      commit('add', formatNotification(data));

      if (rootState?.route?.name === 'Checkout' && data.type === 'error') {
        cartGtmEvents.errorNotificationShown(data.message);
      }

      if (data.lifetime) {
        setTimeout(() => {
          commit('remove', data.id);
        }, data.lifetime * 1000);
      }
    },

    remove({ commit }, id) {
      commit('remove', id);
    },
  },
};

export default notificationStore;
